export default function filterParagraphRates(text: string) {
  return text.trim().split(/[\r\n]+/).map(paragraph => paragraph.trim()).join('<br>')
}
